import "./App.scss";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { createAppTheme } from './theme'; // Import your theme function
import React, { useState, useMemo, useEffect } from 'react';

import Register from "./pages/Auth/Register";
import Login from "./pages/Auth/Login";
import Layout from "./layout/Layout";
import PrivateRoute from "./config/PrivateRoute";
import history from "./utils/HistoryUtils";
import ForgottenPassword from "./pages/Auth/ForgottenPassword";
import ResetPassword from "./pages/Auth/ResetPassword";

function App() {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem('theme') || 'light';
  });

  const theme = useMemo(() => createAppTheme(mode), [mode]);

  // Update HTML data attribute when theme changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);


  const handleThemeChange = (newMode) => {
    setMode(newMode);
    localStorage.setItem('theme', newMode);
  };

  const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    const signeeInfo = localStorage.getItem('signeeInfo');
    try {
      if (token && signeeInfo) {
        return true;
      }
      else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="main-page">
        <Router history={history}>
          <Switch>
            <Route exact path="/login">
              <Login currentTheme={mode} onThemeChange={handleThemeChange} />
            </Route>
            <Route exact path="/register">
              <Register currentTheme={mode} onThemeChange={handleThemeChange} />
            </Route>
            <Route exact path="/forgotten-password">
              <ForgottenPassword currentTheme={mode} onThemeChange={handleThemeChange} />
            </Route>
            <Route exact path="/reset-password">
              <ResetPassword currentTheme={mode} onThemeChange={handleThemeChange} />
            </Route>
            <PrivateRoute 
              path="/" 
              component={Layout} 
              isAuthenticated={e => isAuthenticated()} 
              currentTheme={mode}
              onThemeChange={handleThemeChange}
            />
            <Redirect from="/" to="/login" />
          </Switch>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;